exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".WebCamWidget .portlet-body,.widgetRoot[id*=ImageWidget] .center{text-align:center}.image-display button,.image-display button img{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/css-loader!/builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/sass-loader!./js/css/_imagedisplay.scss
// module id = 67
// module chunks = 0